import { render, staticRenderFns } from "./dutydetails.vue?vue&type=template&id=983f383e&scoped=true&"
import script from "./dutydetails.vue?vue&type=script&lang=js&"
export * from "./dutydetails.vue?vue&type=script&lang=js&"
import style0 from "./dutydetails.vue?vue&type=style&index=0&id=983f383e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983f383e",
  null
  
)

export default component.exports